
import { User } from "@/models/user";
import Vue from "vue";
import { Company } from "@/models/company";
import { Dossier } from "@/models/dossier";
import { CompanyDossierService } from "@/services/company-dossier-service";
export default Vue.extend({
	data() {
		return {
			selectedRows: [] as User[]
		};
	},
	props: {
		value: {
			type: Object as () => Dossier,
			required: true
		},
		company: {
			type: Object as () => Company,
			required: true
		}
	},
	computed: {
		users():User[] {
			return this.company.users.filter((u) => this.value.users.findIndex(a => a.id == u.id) == -1);
		},
		columns():any[] {
			return [
				{
					name: "Id",
					property: "user",
					width: "50px"
				},
				{
					name: "Username",
					property: "username",
					width: "200px"
				},
				{
					name: "Email",
					property: "email"
				}
			];
		}
	},
	methods: {
		cancel() {
			this.$emit("close");
		},
		async add() {
			let val = await CompanyDossierService.addUsers(this.value, this.selectedRows);
			this.$emit("input", val);
			this.$emit("close");
		}
	}
});
